//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.Subdivision.js";
import "../no/Builder.js";
import "../GeometricUtilities/GeometricUtilities.TransformerData.js";
import "../no/ugmath.js";
import "../no/GeometricUtilities.js";
let d=[[[0,"Segments",1,0],[1,"Transformer",0,"GeometricUtilities.TransformerData",0]],[[["selectionData"],"AddSection",{},1,0],[[],"RefitSection",{},0,0]],[]];
SPLM.Features.Subdivision.SectionTubeData = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.Subdivision.SectionTubeData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.Subdivision.SectionTubeData.SelectionData = class{
    constructor(snappedObject,isSnapped,snappedPosition){
        this.snappedObject=snappedObject;this.isSnapped=isSnapped;this.snappedPosition=snappedPosition;}
    get Snappedobject(){return this.snappedObject}
    set Snappedobject(val){this.snappedObject = val}
    get Issnapped(){return this.isSnapped}
    set Issnapped(val){this.isSnapped = val}
    get Snappedposition(){if(this.snappedPosition === undefined) this.snappedPosition = new SPLM.Point3d(); return this.snappedPosition}
    set Snappedposition(val){this.snappedPosition = val}
};

export default SPLM;